
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Pagination extends Vue {
	@Prop({ default: 10 }) readonly limit: number;
	@Prop({ default: 1 }) readonly current: number;
	@Prop({ default: 1 }) readonly total: number;
	@Prop({ default: false }) readonly isDisabled: boolean;
	@Prop({ default: '', required: false }) readonly paginationClasses: string;

	onLimitChange(e) {
		this.$emit('limit-change', e.target.value);
	}

	nextPage() {
		this.$emit('next-page');
	}
	prevPage() {
		this.$emit('prev-page');
	}
}
